import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {CompanyDetailsData} from "./company-details.data";
import {TranslateService} from "@ngx-translate/core";

@Injectable()
export class CompanyDetailsEntityModel extends EntityModel<CompanyDetailsData> {

    constructor(injector: Injector, private translate: TranslateService) {
        super(injector, CompanyDetailsData);
    }

    protected override onNewEntity(entityData: CompanyDetailsData): void {
        super.onNewEntity(entityData);
        // OnNewEntity is called in the EntityModel constructor so the translateService is not available
        setTimeout(() => {
            this.translate.get("wbo.company-details.edit.option.useridentifier.none")
                .subscribe((value) => entityData.receiptConfiguration.userIdentifier = value);
            entityData.receiptConfiguration.printAbn = false;
            entityData.receiptConfiguration.includeTaxesInPriceLines = false;
            entityData.receiptConfiguration.printGstNumber = false;
            entityData.receiptConfiguration.itemiseExtras = false;
        });
    }
}
